import React from 'react';

import { Box, IconButton, Typography } from '@mui/material';

import Icons from '../../../themes/icons';
import Button from '../../Button/Button';
import BaseDialog, { BaseDialogProps } from '../Base';

type Props = {
  onConfirmationHandle: (extendedDays: number) => void;
} & BaseDialogProps;

export const ExtendPostingTimeDialog: React.FC<Props> = ({ onConfirmationHandle, ...rest }) => {
  const [postingDays, setPostingDays] = React.useState(1);

  const onPostingDaysHandle = (operation: 'add' | 'remove') => {
    if (operation === 'add') {
      setPostingDays((prev) => prev + 1);
    } else {
      if (postingDays > 1) {
        setPostingDays((prev) => prev - 1);
      }
    }
  };

  return (
    <BaseDialog
      width='360px'
      height='320px'
      titleComponent={
        <Typography fontSize={'18px'} fontWeight={500}>
          Extend posting time
        </Typography>
      }
      {...rest}
    >
      <Box mt={3}>
        <Box display={'flex'} alignItems={'center'} gap={'16px'}>
          <IconButton
            sx={{ p: '16px 12px', borderRadius: '8px', border: '1px solid #e6e6e6' }}
            onClick={() => onPostingDaysHandle('remove')}
          >
            <Icons.RemoveIcon />
          </IconButton>
          <Box
            sx={{
              borderRadius: '8px',
              border: '1px solid #e6e6e6',
              p: '16px 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flex: 1,
            }}
          >
            <Typography>{postingDays}</Typography>
            <Typography color='#B3B3B3'>Days</Typography>
          </Box>
          <IconButton
            sx={{ p: '16px 12px', borderRadius: '8px', border: '1px solid #e6e6e6' }}
            onClick={() => onPostingDaysHandle('add')}
          >
            <Icons.AddIcon />
          </IconButton>
        </Box>

        <Box display={'flex'} flexDirection={'column'} gap={'16px'} mt={5}>
          <Button
            variant='contained'
            color='primary'
            fullWidth
            sx={{ p: '14px 24px' }}
            onClick={() => {
              onConfirmationHandle(postingDays);
              rest.onClose?.({}, 'escapeKeyDown');
            }}
          >
            Confirm and extend
          </Button>
          <Button
            onClick={() => {
              if (rest?.onClose) rest?.onClose({}, 'escapeKeyDown');
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
};
